import type { NextPage } from "next";
import PageLayout from "@components/PageLayout";

import ClaimKep from "@components/ClaimKep";
// import ClaimKepRightSidebar from "@components/ClaimKepRightSidebar";

const ClaimKepPage: NextPage = () => {
  return (
    <PageLayout
    // RightSidebar={<ClaimKepRightSidebar />}
    >
      <ClaimKep />
    </PageLayout>
  );
};

export default ClaimKepPage;
